// globals: jQuery, Ajax, I4go, reportAjaxError, TakePayment

var I4goIframeAbstract;

(function($) {

    I4goIframeAbstract = function(config) {
        this.config = {};
        if (config) {
            this.config = $.extend(this.config, config);
        }
        this.i4go = new I4go();
    };

    I4goIframeAbstract.prototype.isSuccess = false;

    I4goIframeAbstract.prototype.setI4goParamsToForm = function($form, data, callback) {

        data.expiration_date = data.i4go_expirationyear + '-' + data.i4go_expirationmonth + '-01';
        var firstDigit = this.i4go.getFirstDigitByCreditType(data.i4go_cardtype);
        var ccNumberEscape = firstDigit + Array(12).join('*') + data.i4go_uniqueid.slice(0, 4);
        data.cc_number = ccNumberEscape;

        $form.find('[name=cc_merchant_unique_id]').val(data.i4go_uniqueid);
        $form.find('[name=cc_date], [name="ccInfo[expDate]"]').val(data.expiration_date);
        $form.find('[name=cc_number],[name="ccInfo[ccNumber]"],[name=card_number]').val(data.cc_number);
        // if customer name is not empty this means that transaction happen with the swipe because in our iframe
        // we don't have fields for name at all
        var swipeHappen = data.otn && data.otn.customername && data.otn.customername.trim() !== '' && data.otn.zipcode === '' ? 1 : 0;
        $form.find('[name=shift4_swipe_flag]').val(swipeHappen);
        callback();
    };

    I4goIframeAbstract.prototype.openEmvTerminal = function() {
        var self = this;
        var shift4LocalUtgUrl = jQuery('#call-emv-url').val();
        TakePayment.callTerminal(
            {
                shift4LocalUtgUrl: shift4LocalUtgUrl
            },
            function(data) {
                var $dialogContent = jQuery('<div><p class="pos-terminal-text">Please process payment through the EMV terminal.</p></div>');
                var url = '/payment/emv-terminal-create-token';
                new Ajax.Request(
                    url,
                    {
                        method: 'post',
                        parameters: data,
                        onComplete: function (request) {
                            $dialogContent.caDialog('close');
                            var responseJSON = request.responseJSON;
                            if (request.status === 0) {
                                return false;
                            }
                            if (responseJSON.status === 1) {
                                self.onEmvSuccess(responseJSON.token);
                            }
                        },
                        onFailure: reportAjaxError
                    }
                );
                $dialogContent.caDialog({
                    title: 'Transaction In Progress...',
                    resizable: false,
                    width: 600,
                    showCloseButton: false,
                    modal: true
                });
            }
        );
    };

    I4goIframeAbstract.prototype.init = function(initConfig) {
        var self = this;
        self.isSuccess = false;
        if (initConfig) {
            this.config = $.extend(this.config, initConfig);
        }
        if (!$('#' + this.config.frameContainer).length) {
            return false;
        }

        if (this.config.isEmvTerminal) {
            var $useEmvTerminalBtn = $(this.config.formSelector)
                .find('#useEmvTerminalBtn');
            $useEmvTerminalBtn.removeClass('hidden');
            $useEmvTerminalBtn.on('click', function() {
                self.openEmvTerminal();
            });

        }
        this.i4go.getAuthorizeClientResponse(function (params) {
            $(function () {
                self.initI4goTrueToken({
                    server: params.i4go_server,
                    accessBlock: params.i4go_accessblock,
                    location: document.location
                });
            });
        });
    };

    I4goIframeAbstract.prototype.onEmvSuccess = function() {
    };

    I4goIframeAbstract.prototype.onSuccess = function() {
    };

    I4goIframeAbstract.prototype.onFailure = function() {
    };

    I4goIframeAbstract.prototype.onComplete = function() {
    };

    I4goIframeAbstract.prototype.initI4goTrueToken = function(data) {
        var self = this;
        var acceptedDefaultPayments = "AX,DC,GC,JC,MC,NS,VS";
        var i4goTrueTokenFramer = $(this.config.formSelector).i4goTrueToken({
            encryptedOnlySwipe: this.config.deviceEntryOnly || false,
            deviceEntryOnly: {
                required: this.config.deviceEntryOnly || false,
            },

            server: data.server, // REQUIRED - get this from access.i4go.com call (or i4access.shift4test.com)
            accessBlock: data.accessBlock, // REQUIRED - get this from access.i4go.com call (or i4access.shift4test.com)
            self: data.location, // REQUIRED - the full URL used to locate the current page
            // MUST MATCH EXACTLY INCLUDING QUERY PARAMETERS - document.location should work
            template: this.config.template, // the template you want (currently defaults to bootstrap3 - horizontal)
            // Options:
            // bootstrap2
            // bootstrap2 - horizontal
            // bootstrap3
            // bootstrap3 - horizontal
            // plain
            // table
            url: "", // i4go server
            // If not provided (the default), value will be calculated based on the "server" parameter
            // Defaults to production
            // Must override for testing and certification to https://form.shift4test.com
            frameContainer: this.config.frameContainer, // Only used if frameName does not exist
            frameName: "", // Auto - assigned if left empty
            frameAutoResize: this.config.frameAutoResize || false,
            frameClasses: "",
            formAutoSubmitOnSuccess: false,
            formAutoSubmitOnFailure: false,
            onSuccess: function (form, data) {
                if (self.isSuccess) {
                    return false;
                }
                self.isSuccess = true;

                var $form = self.config.i4goParamsToFormSelector ? $(self.config.i4goParamsToFormSelector) : $(form);
                self.setI4goParamsToForm($form, data, function() {
                    self.onSuccess($form, data);
                });
            },
            onFailure: function (form, data) {
                self.onFailure(form, data);
            },
            onComplete: function (form, data) {
                self.onComplete(form, data);
            },
            acceptedPayments: this.config.acceptedPayments ? this.config.acceptedPayments : acceptedDefaultPayments, // Auto populated form fields. Precedence: field name, field id
            formPaymentResponse: "i4go_response",
            formPaymentResponseCode: "i4go_responsecode",
            formPaymentResponseText: "i4go_responsetext",
            formPaymentMaskedCard: "i4go_maskedcard",
            formPaymentToken: "i4go_uniqueid",
            formPaymentExpMonth: "i4go_expirationmonth",
            formPaymentExpYear: "i4go_expirationyear",
            formPaymentType: "i4go_cardtype",
            // Advanced Options
            // payments: [
            // { type: "VS", name: "Visa" },
            // { type: "MC", name: "MasterCard" },
            // { type: "AX", name: "American Express" },
            // { type: "DC", name: "Diners Club" },
            // { type: "NS", name: "Discover" },
            // { type: "JC", name: "JCB" },
            // { type: "GC", name: "Gift Card" }
            // ],
            // body: { styles:{ "background-color": "##aaa", borderLeft: "5px solid ##ccc" } },
            // label: { classes:"control-label col-xs-4" },
            label: this.config.label,
            // container: { classes:"" },
            // cardType: { classes:"", label:"", placeholder:"", message:"", required:true },
            // expirationMonth: { classes:"", label:"", placeholder:"", message:"" },
            // expirationYear: { classes:"", label:"", placeholder:"", message:"" },

            cvv2Code: { classes:"", label:"CVV", placeholder:"", message:"", required:this.config.cvvRequired, visible:this.config.cvvRequired },
            // streetAddress: { classes:"", label:"Street Address", placeholder:"", message:"", visible:true },
            postalCode: { classes:"", label:"Billing Zip Code", placeholder:"", message:"", required:this.config.avsRequired, visible:this.config.avsRequired },

            //
            //cssRules: [
            // "body{background-color: ##aaa;font-family:"Trebuchet MS", Arial, Helvetica, sans-serif;}",
            // "body{text-size: ""}",
            // "label{color:##444;font-size:80%;font-weight:bold;}"
            // ],
            cssRules: this.config.cssRules
            // // Debug flags: Simply creates additional console log messages
            // // A debugger needs to be running to view. In no event does CHD get logged.
            //debug: true // Parent side
            // remoteDebug: false // Adds width indicators within the iframe contents to help with frame sizing
        });

        $.cardswipe({
            firstLineOnly: false,
            success: function (data) {
                i4goTrueTokenFramer.sendSwipeToFrame(data);
            },
            error: function() {
                $.caAlert("Swipe failed!");
            },
            debug: false
        });
    };

})(jQuery);

export default I4goIframeAbstract;
